import { Api } from 'src/apis/api';
import { noStateFieldLocales } from 'src/constants/stateField';
import { IImportLeadPayload } from 'src/types/api';
import { IProduct } from 'src/types/product';

import { getCookie, removeCookie } from './cookies';
import { konnektiveProductToIProduct } from './products';
import { getSlug, getUrlParameters, removeUrlParams } from './url';
import { getAppUtms } from './utms';

export const isCurrentProductTaken = async (
  orderId: string,
  productId: string,
) => {
  const order = await Api.queryOrder(orderId);
  return Boolean(
    order?.products?.find(el => String(el?.productId) === String(productId)),
  );
};

export const stateIsRequired = () => {
  const slug = getSlug();
  const stateIsNotRequired = noStateFieldLocales.some(locale =>
    slug.startsWith(locale),
  );
  return !stateIsNotRequired;
};

const getKonnektiveLead = async (orderId: string, campaignId: number) => {
  const params = getUrlParameters();
  const orderInfo = await Api.queryOrder(orderId);
  if (!orderInfo) {
    // prospect_id or order_id is probably malformed so we need to remove it
    removeCookie('order_id');
    removeUrlParams(['order_id', 'prospect_id']);
    return {
      purchased: [],
      lead: {} as IImportLeadPayload,
    };
  }

  const state = stateIsRequired() ? orderInfo.state : '';
  const purchased = konnektiveProductToIProduct(orderInfo);
  const sessionId = params['session_id'] || orderInfo.customFields?.sid;

  return {
    purchased,
    lead: {
      ...getAppUtms(),
      state,
      orderId,
      sessionId,
      campaignId,
      client: window.BRAND,
      paySource: orderInfo.paySource,
      emailAddress: orderInfo.emailAddress,
      firstName: orderInfo.firstName,
      lastName: orderInfo.lastName,
      country: orderInfo.country,
      city: orderInfo.city,
      address1: orderInfo.address1,
      phoneNumber: orderInfo.phoneNumber,
      postalCode: orderInfo.postalCode,
      ipAddress: orderInfo.ipAddress,
      billShipSame: true,
      ...orderInfo?.customFields,
    } as IImportLeadPayload,
  };
};

export const getLead = async (
  campaignId: number,
): Promise<{
  lead: IImportLeadPayload;
  purchased: IProduct[];
}> => {
  const params = getUrlParameters();
  const oid =
    params['order_id'] ?? params['prospect_id'] ?? getCookie('order_id');

  if (oid) {
    const { lead, purchased } = await getKonnektiveLead(oid, campaignId);
    return {
      lead,
      purchased,
    };
  }

  removeCookie('purchased');
  return {
    lead: {} as IImportLeadPayload,
    purchased: [],
  };
};
